import VerifyingIcon from './VerifyingIcon';
import styled from 'styled-components';

export default styled(VerifyingIcon)`
  position: absolute;
  left: -2.5em;
  transform: scale(0.5);
`;
